import { useTranslation } from 'react-i18next';
export default function PlacementSelectorHeader() {
  const { t } = useTranslation();
  return (
    <div className="mb-2 h-[180px] md:h-[320px] text-center flex flex-col justify-center items-center">
      <div
        className="text-uppercase font-medium text-sm"
        style={{ color: '#BF4B30' }}
      >
        {t('header_current_step', { currentStep: 4, totalSteps: 7 })}
      </div>
      <h1 className="text-2xl md:text-5xl font-bold">
        {' '}
        {t('choose_placement_title')}
      </h1>
      <p>{t('choose_placement_description')}</p>
      <br />
    </div>
  );
}
